import { render, staticRenderFns } from "./VideoEmbeds.vue?vue&type=template&id=a8765118&scoped=true"
import script from "./VideoEmbeds.vue?vue&type=script&lang=js"
export * from "./VideoEmbeds.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbeds.vue?vue&type=style&index=0&id=a8765118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8765118",
  null
  
)

export default component.exports